import {useTranslation} from 'react-i18next';
import { useHistory } from 'react-router-dom';
import FullScreenStepper from 'components/FullScreenStepper/FullScreenStepper';
import Onboarding_Lesson_intro from './Onboarding_Lesson_intro';
import Onboarding_Environment from 'components/Onboarding/Onboarding_Environment';
import Onboarding_Materials from 'components/Onboarding/Onboarding_Materials';
import Onboarding_Print from 'components/Onboarding/Onboarding_Print';
import Onboarding_Locked from 'components/Onboarding/Onboarding_Locked';
// import Onboarding_Register from 'components/Onboarding/Onboarding_Register';

const LessonOnboarding = ({lessonImgURL, teaserThumbnail, name, description, instructorName, AnimalType, stepRequirements, lessonPathname, onFinish, onExit, exitButtonType = 'x', teaserUrl, VolumeSwitchState, onIntroCompleted, isLocked, onSubscribe}) => {
  const {t, i18n} = useTranslation();
  const history = useHistory();

  const steps = [
    <Onboarding_Lesson_intro
      lessonImgURL={lessonImgURL}
      teaserThumbnail={teaserThumbnail}
      name={name}
      description={description}
      instructorName={instructorName}
      AnimalType={AnimalType}
      teaserUrl={teaserUrl}
      VolumeSwitchState={VolumeSwitchState}
      onIntroCompleted={onIntroCompleted}
    />,
    // <Onboarding_Environment/>,
    <Onboarding_Materials stepRequirements={stepRequirements}/>,
    <Onboarding_Print
      lessonPathname={lessonPathname}
    />,
    // <Onboarding_Register/>,
  ];

  // Commented out on Feb 28, 2026 — due to the war with Iran, we want children
  // to enjoy the site for free during these hard times.
  // if (isLocked) {
  //   steps.push(
  //     <Onboarding_Locked
  //       lessonPathname={lessonPathname}
  //       lessonImgURL={lessonImgURL}
  //       name={name}
  //       AnimalType={AnimalType}
  //       onSubscribe={onSubscribe}
  //     />
  //   );
  // }

  return (
    <>
        <FullScreenStepper
            exitButtonType={exitButtonType}
            steps={steps}
            onFinish={onFinish}
            onExit={onExit}
        />
    </>
  )
}


export default LessonOnboarding;



// function StepOne({ onContinue }) {
//   return (
//     <div>
//       <h1>Step 1 22</h1>
//       <button onClick={onContinue}>Continue</button>
//     </div>
//   );
// }